import styles from './index.module.scss';

function Spacer() {
  return <div className={styles.spacer} />;
}

export default Spacer;
